import { render, staticRenderFns } from "./EventFriendButton.vue?vue&type=template&id=66e2d408"
import script from "./EventFriendButton.vue?vue&type=script&lang=js"
export * from "./EventFriendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports